import {Dispatch} from "redux";
import {DRUG_BATCH_STORE_STATE, DrugBatchDispatchTypes} from "./DrugBatchActionTypes";
import {getDataFromServiceWithData} from "store-fetch-wrappers";
import MMApiModel from "../../apiModel/MMApiModel";
import {statusCodeCallback} from "../../helpers/storeHelpers";
import {RootStore} from "../../Store";

export const fetchDrugBatchesWithinPack = (packId: number) => {
    return async (dispatch: Dispatch<DrugBatchDispatchTypes>, state: () => RootStore) => {
        try {
            const drugBatches = await getDataFromServiceWithData(
                DRUG_BATCH_STORE_STATE,
                dispatch,
                () => MMApiModel.getDefaultApi().getDrugBatchesWithinPack(packId),
                statusCodeCallback
            );
            const drugBatchesInPacks = state().drugBatches.data;

            if (drugBatches && drugBatchesInPacks) {
                drugBatchesInPacks.set(packId, drugBatches);

                dispatch({
                    type: DRUG_BATCH_STORE_STATE.SUCCESS,
                    error: null,
                    loading: false,
                    data: drugBatchesInPacks
                });
            }
        } catch (e: any) {
            dispatch({
                type: DRUG_BATCH_STORE_STATE.ERROR,
                loading: false,
                error: e
            });
        }
    };
};
